<template>
  <tsl-card class="charts" :cardList="cardList">
    <template v-slot:overview>
      <div id="usage-room-chart"></div>
    </template>
    <template v-slot:topRight>
      <a-range-picker class="data-picker" />
      <chart-date-tabs :data="dateData"></chart-date-tabs>
    </template>
  </tsl-card>
</template>

<script>
import Card from "@/components/tsl-card/index.vue";
import chart from "@/components/charts";
import Tabs from "@/components/chart-date-tabs/index.vue";
import { DatePicker } from "ant-design-vue";
import { onMounted, reactive, ref, onUnmounted } from "vue";
const RangePicker = DatePicker.RangePicker;
export default {
  name: "overview-charts",
  components: {
    [Card.name]: Card,
    [Tabs.name]: Tabs,
    [RangePicker.name]: RangePicker
  },
  setup() {
    const dateData = ref(["今日", "近七天", "近30天"]);
    const cardList = reactive([
      {
        name: "overview",
        title: "操作事件",
        topRight: "topRight"
      }
    ]);
    const chartData = {
      dimensions: ["time", "本地审计", "云端审计"],
      source: {
        time: ["1/1", "1/2", "1/3", "1/4", "1/5", "1/6", "1/7"],
        本地审计: [20, 32, 20, 16, 17, 28, 30],
        云端审计: [26, 36, 26, 14, 27, 16, 45]
      }
    };
    const echart = ref({});

    onMounted(() => {
      echart.value = chart.setBarAuditOverview(chartData, "usage-room-chart");
    });

    onUnmounted(() => {
      echart.value.remove();
    });

    return {
      dateData,
      cardList
    };
  }
};
</script>

<style lang="less" scoped>
.charts {
  height: 406px !important;
}
:deep(.rcon) {
  display: flex;
  .data-picker {
    margin: 0 16px;
  }
}
#usage-room-chart {
  width: 100%;
  height: 306px;
}
</style>
